import {
    DailySummaryType,
    FoodLogItemNutritionType,
    DisplayType,
    ScoreType,
    ScoresBreakdownType,
    ScoreCategoryDetailType,
    ProteinBonusType,
    DailyInsightsType,
    userType,
} from "../../DTO";
import { Api } from "../api";
import { convertToFoodTypeList } from "./food-log/list";

interface IDailySummaryParams {
    appUser: userType;
    userId: number;
    dayId: number;
}

export const DailySummary = (params: IDailySummaryParams) => {
    return new Promise<{ daily_summary: DailySummaryType }>((resolve, reject) => {
        const api = new Api({
            method: "get",
            path: `summary/daily/user/${params.userId}/${params.dayId}`,
            header: {
                Authorization: `Bearer ${params.appUser.access_token}`,
            },
        });

        return api
            .call()
            .then((data: any) =>
                resolve({
                    daily_summary: convertToDailySummaryType(data.data),
                }),
            )
            .catch((err) => reject(err.data.message));
    });
};

export const convertToDailySummaryType = (data: any): DailySummaryType => {
    const out: DailySummaryType = {
        id: data?.id,
        daily_task_id: data?.daily_task_id,
        has_summary: data?.has_summary,
        display: convertToDisplayType(data?.display),
        score: convertToScoreType(data?.score),
        scores_breakdown: convertToScoresBreakdownType(data?.scores_breakdown),
        protein_bonus: convertToProteinBonusType(data?.protein_bonus),
        insights: convertToDailyInsightsType(data?.insights),
        ai_summary: data?.ai_summary,
        nutrition_totals: convertToNutritionType(data?.nutrition_totals),
        suggestions: data?.suggestions || [],
        generated_at: data?.generated_at,
        food_logs: Array.isArray(data?.food_logs)
            ? convertToFoodTypeList(data?.food_logs)
            : [],
    };

    return out;
};

const convertToDisplayType = (data: any): DisplayType => {
    return {
        title: data?.title || "",
        light: data?.light || "green",
        color_code: data?.color_code || "#22C55E",
        emoji: data?.emoji || "",
    };
};

const convertToScoreType = (data: any): ScoreType => {
    return {
        total: data?.total || 0,
        max: data?.max || 100,
        percentage: data?.percentage || 0,
    };
};

const convertToScoresBreakdownType = (data: any): ScoresBreakdownType => {
    return {
        carbs: convertToScoreCategoryDetailType(data?.carbs),
        sugar: convertToScoreCategoryDetailType(data?.sugar),
        fiber: convertToScoreCategoryDetailType(data?.fiber),
        protein: convertToScoreCategoryDetailType(data?.protein),
    };
};

const convertToScoreCategoryDetailType = (
    data: any
): ScoreCategoryDetailType => {
    return {
        points: data?.points || 0,
        max: data?.max || 25,
        light: data?.light || "green",
    };
};

const convertToProteinBonusType = (data: any): ProteinBonusType => {
    return {
        earned: data?.earned || false,
        points: data?.points || 0,
        high_protein_meals: data?.high_protein_meals || 0,
        required_meals: data?.required_meals || 0,
    };
};

const convertToDailyInsightsType = (data: any): DailyInsightsType => {
    return {
        worst_category: data?.worst_category || "",
        daily_insight: data?.daily_insight || "",
        tomorrow_focus: data?.tomorrow_focus || "",
    };
};

const convertToNutritionType = (data: any): FoodLogItemNutritionType => {
    return {
        calories: data?.calories || 0,
        protein: data?.protein || 0,
        carbohydrates: data?.carbohydrates || 0,
        fat: data?.fat || 0,
        fiber: data?.fiber || 0,
        sugar: data?.sugar || 0,
        sodium: data?.sodium || 0,
        cholesterol: data?.cholesterol || 0,
        saturated_fat: data?.saturated_fat || 0,
        trans_fat: data?.trans_fat || 0,
    };
};
